import { render, staticRenderFns } from "./CostsWrapper.vue?vue&type=template&id=a1d935de&"
import script from "./CostsWrapper.vue?vue&type=script&lang=js&"
export * from "./CostsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports